import type { ReactElement } from "react";

export const ThemeColors = (): ReactElement => {
  return <div>Colors page</div>;
};
